import api from './api';

// Boş/null parametreleri düşür — sorgu dizesi temiz kalsın (leaveBalanceReportService deseni).
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

// Kadro bazlı işe alım raporu. Filtreler bracket-notation ile geçilir
// (departmentId[eq], status[in], hiringManagerUserId[eq], approvedAt[gte]/[lte]) —
// AtsRequisitionController'daki kalıbın aynısı, AtsRecruitingReportController'a gider.
export const getAtsRecruitingReport = (params) =>
  api.get('/v1/ats-recruiting-report', { params: clean(params) });

// Ekranla AYNI filtre + AYNI gövdeden üretilir (backend BuildRowsForIds) — ikinci
// bir sorgu/mantık yok, yalnız sayfalama devre dışı (tüm filtrelenmiş küme).
export const exportAtsRecruitingReport = (params) =>
  api.get('/v1/ats-recruiting-report/export', { params: clean(params), responseType: 'blob' });
